import { Outlet, useParams } from "@tanstack/react-router";
import { IntlProvider } from "@/i18n/IntlProvider";
import { type Locale } from "@qrody/i18n";

/**
 * Locale-prefix layout — every URL carries /de or /en. The
 * IntlProvider loads the right message bundle on demand.
 */
export function LocaleLayout() {
  const { locale } = useParams({ strict: false }) as { locale?: string };
  return (
    <IntlProvider initialLocale={(locale as Locale | undefined) ?? "de"}>
      <Outlet />
    </IntlProvider>
  );
}
